import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

class SeeMeItem extends Component {
    constructor(props, context) {
        super(props, context);
        this.getDetails = this.getDetails.bind(this);
    }    

    getDetails() {
        return `/Gigs/${this.props.gig.ID}`;
    }

    render() {        
        let gig = this.props.gig;
        let gigDate = new Date(gig.Date);
        return (
            <tr>
                <td>{gigDate.toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                <td>{gigDate.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}</td>
                <td>{gig.Title}</td>
                <td>{gig.Location}</td>
                <td>{gig.Venue}</td>
                <td><Link to={this.getDetails()}>Details</Link></td>
            </tr>        
        );
    }
}

SeeMeItem.propTypes = {
    gig: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default SeeMeItem;